export const SALES_VAT_RATES_FILTER_KEY = 'sales_vat_rates'
